import axios from 'axios';

const state = {};

const getters = {};

const actions = {
	// Analisi Google Merchant di un prodotto (stato, rendimento, prezzo, best seller).
	// Ritorna { data } oppure { error: { message } }.
	fetchItem: async (context, payload) => {
		return await axios
			.post(`${context.rootGetters['settings/getUrl']}googlemerchant/insights/item`, { item: payload.item }, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })
			.then(res => res.data)
			.catch(err => ({ error: err.response ? err.response.data : { message: err.message } }));
	},
};

const mutations = {};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
